module.exports = __webpack_public_path__ + "static/media/tie.4a04f9f0.svg";